"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayConnectionReportPageEntity = exports.DisplayConnectionReportDisplayEntity = exports.DisplayConnectionReportSummaryEntity = exports.DisplayConnectionReportDailyPointEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
class DisplayConnectionReportDailyPointEntity {
    date;
    connectedSeconds;
    observedSeconds;
    estimatedSeconds;
    evidenceSeconds;
    possibleSeconds;
    connectionPercent;
}
exports.DisplayConnectionReportDailyPointEntity = DisplayConnectionReportDailyPointEntity;
__decorate([
    (0, swagger_1.ApiProperty)({ example: "2026-09-01", description: "Fecha local de Europe/Madrid" }),
    __metadata("design:type", String)
], DisplayConnectionReportDailyPointEntity.prototype, "date", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos de conexión atribuidos" }),
    __metadata("design:type", Number)
], DisplayConnectionReportDailyPointEntity.prototype, "connectedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos atribuidos desde eventos de conectividad" }),
    __metadata("design:type", Number)
], DisplayConnectionReportDailyPointEntity.prototype, "observedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos estimados desde otras señales" }),
    __metadata("design:type", Number)
], DisplayConnectionReportDailyPointEntity.prototype, "estimatedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos con evidencia de actividad o conectividad" }),
    __metadata("design:type", Number)
], DisplayConnectionReportDailyPointEntity.prototype, "evidenceSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Segundos posibles del día local para todas las pantallas incluidas",
    }),
    __metadata("design:type", Number)
], DisplayConnectionReportDailyPointEntity.prototype, "possibleSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        type: Number,
        nullable: true,
        description: "connectedSeconds / possibleSeconds × 100",
    }),
    __metadata("design:type", Object)
], DisplayConnectionReportDailyPointEntity.prototype, "connectionPercent", void 0);
class DisplayConnectionReportSummaryEntity {
    from;
    to;
    generatedAt;
    requestedDisplays;
    includedDisplays;
    excludedDisplays;
    connectedSeconds;
    observedSeconds;
    estimatedSeconds;
    evidenceSeconds;
    possibleSeconds;
    connectionPercent;
    dataCoveragePercent;
    unavailableDisplayDays;
    daily;
}
exports.DisplayConnectionReportSummaryEntity = DisplayConnectionReportSummaryEntity;
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time", description: "Inicio UTC incluido" }),
    __metadata("design:type", String)
], DisplayConnectionReportSummaryEntity.prototype, "from", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time", description: "Fin UTC excluido" }),
    __metadata("design:type", String)
], DisplayConnectionReportSummaryEntity.prototype, "to", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time" }),
    __metadata("design:type", String)
], DisplayConnectionReportSummaryEntity.prototype, "generatedAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Pantallas encontradas por search o displayIds" }),
    __metadata("design:type", Number)
], DisplayConnectionReportSummaryEntity.prototype, "requestedDisplays", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Pantallas incluidas en las métricas" }),
    __metadata("design:type", Number)
], DisplayConnectionReportSummaryEntity.prototype, "includedDisplays", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Pantallas excluidas del denominador" }),
    __metadata("design:type", Number)
], DisplayConnectionReportSummaryEntity.prototype, "excludedDisplays", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos de conexión atribuidos" }),
    __metadata("design:type", Number)
], DisplayConnectionReportSummaryEntity.prototype, "connectedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos atribuidos desde eventos de conectividad" }),
    __metadata("design:type", Number)
], DisplayConnectionReportSummaryEntity.prototype, "observedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos estimados desde otras señales" }),
    __metadata("design:type", Number)
], DisplayConnectionReportSummaryEntity.prototype, "estimatedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos con evidencia de actividad o conectividad" }),
    __metadata("design:type", Number)
], DisplayConnectionReportSummaryEntity.prototype, "evidenceSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Pantallas incluidas × duración del intervalo en segundos" }),
    __metadata("design:type", Number)
], DisplayConnectionReportSummaryEntity.prototype, "possibleSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        type: Number,
        nullable: true,
        description: "connectedSeconds / possibleSeconds × 100",
    }),
    __metadata("design:type", Object)
], DisplayConnectionReportSummaryEntity.prototype, "connectionPercent", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        type: Number,
        nullable: true,
        description: "evidenceSeconds / possibleSeconds × 100",
    }),
    __metadata("design:type", Object)
], DisplayConnectionReportSummaryEntity.prototype, "dataCoveragePercent", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Pares pantalla/día local sin evidencia dentro del intervalo" }),
    __metadata("design:type", Number)
], DisplayConnectionReportSummaryEntity.prototype, "unavailableDisplayDays", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: [DisplayConnectionReportDailyPointEntity] }),
    __metadata("design:type", Array)
], DisplayConnectionReportSummaryEntity.prototype, "daily", void 0);
class DisplayConnectionReportDisplayEntity {
    displayId;
    ref;
    name;
    /** Cabify uses display_tech_info as its license plate. */
    displayTechInfo;
    plate;
    groupId;
    ownerId;
    providerId;
    isArchived;
    isConnectedNow;
    lastConnectionAt;
    excludedFromSummary;
    lastSeenAtAsOf;
    connectedSeconds;
    observedSeconds;
    estimatedSeconds;
    evidenceSeconds;
    possibleSeconds;
    connectionPercent;
    dataCoveragePercent;
}
exports.DisplayConnectionReportDisplayEntity = DisplayConnectionReportDisplayEntity;
__decorate([
    (0, swagger_1.ApiProperty)({ description: "ID interno de la pantalla" }),
    __metadata("design:type", String)
], DisplayConnectionReportDisplayEntity.prototype, "displayId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Referencia pública display_id" }),
    __metadata("design:type", String)
], DisplayConnectionReportDisplayEntity.prototype, "ref", void 0);
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", String)
], DisplayConnectionReportDisplayEntity.prototype, "name", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: String, nullable: true, description: "Valor original de display_tech_info" }),
    __metadata("design:type", Object)
], DisplayConnectionReportDisplayEntity.prototype, "displayTechInfo", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        type: String,
        nullable: true,
        description: "Matrícula extraída de display_tech_info",
    }),
    __metadata("design:type", Object)
], DisplayConnectionReportDisplayEntity.prototype, "plate", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: String, nullable: true }),
    __metadata("design:type", Object)
], DisplayConnectionReportDisplayEntity.prototype, "groupId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: String, nullable: true }),
    __metadata("design:type", Object)
], DisplayConnectionReportDisplayEntity.prototype, "ownerId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: String, nullable: true }),
    __metadata("design:type", Object)
], DisplayConnectionReportDisplayEntity.prototype, "providerId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", Boolean)
], DisplayConnectionReportDisplayEntity.prototype, "isArchived", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Estado actual; no representa necesariamente el intervalo consultado",
    }),
    __metadata("design:type", Boolean)
], DisplayConnectionReportDisplayEntity.prototype, "isConnectedNow", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        type: String,
        nullable: true,
        format: "date-time",
        description: "Última conexión registrada actualmente (last_connection_at), independiente de from/to. No es la hora de desconexión; null si no se conoce.",
    }),
    __metadata("design:type", Object)
], DisplayConnectionReportDisplayEntity.prototype, "lastConnectionAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", Boolean)
], DisplayConnectionReportDisplayEntity.prototype, "excludedFromSummary", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        type: String,
        nullable: true,
        format: "date-time",
        description: "Última señal conocida anterior al fin exclusivo to. Dato histórico; para la última conexión actual use lastConnectionAt.",
    }),
    __metadata("design:type", Object)
], DisplayConnectionReportDisplayEntity.prototype, "lastSeenAtAsOf", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos de conexión atribuidos" }),
    __metadata("design:type", Number)
], DisplayConnectionReportDisplayEntity.prototype, "connectedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos atribuidos desde eventos de conectividad" }),
    __metadata("design:type", Number)
], DisplayConnectionReportDisplayEntity.prototype, "observedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos estimados desde otras señales" }),
    __metadata("design:type", Number)
], DisplayConnectionReportDisplayEntity.prototype, "estimatedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos con evidencia de actividad o conectividad" }),
    __metadata("design:type", Number)
], DisplayConnectionReportDisplayEntity.prototype, "evidenceSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Duración del intervalo en segundos" }),
    __metadata("design:type", Number)
], DisplayConnectionReportDisplayEntity.prototype, "possibleSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        type: Number,
        nullable: true,
        description: "connectedSeconds / possibleSeconds × 100",
    }),
    __metadata("design:type", Object)
], DisplayConnectionReportDisplayEntity.prototype, "connectionPercent", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        type: Number,
        nullable: true,
        description: "evidenceSeconds / possibleSeconds × 100",
    }),
    __metadata("design:type", Object)
], DisplayConnectionReportDisplayEntity.prototype, "dataCoveragePercent", void 0);
class DisplayConnectionReportPageEntity {
    from;
    to;
    generatedAt;
    results;
    total;
    page;
    limit;
}
exports.DisplayConnectionReportPageEntity = DisplayConnectionReportPageEntity;
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time" }),
    __metadata("design:type", String)
], DisplayConnectionReportPageEntity.prototype, "from", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time" }),
    __metadata("design:type", String)
], DisplayConnectionReportPageEntity.prototype, "to", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time" }),
    __metadata("design:type", String)
], DisplayConnectionReportPageEntity.prototype, "generatedAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: [DisplayConnectionReportDisplayEntity] }),
    __metadata("design:type", Array)
], DisplayConnectionReportPageEntity.prototype, "results", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Total de pantallas tras aplicar filter, antes de paginar" }),
    __metadata("design:type", Number)
], DisplayConnectionReportPageEntity.prototype, "total", void 0);
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", Number)
], DisplayConnectionReportPageEntity.prototype, "page", void 0);
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", Number)
], DisplayConnectionReportPageEntity.prototype, "limit", void 0);
